import axios from 'axios';

const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL;
// const baseUrlActive = process.REACT_APP_AWS_API_GATEWAY_URL_EXECUTE_FLOW;

export const fetchAllSuppliers = (accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            "process": "supplier_select",
            "action": "LIST_ALL",
            "variables": `{}`
        })
    });
}

export const fetchSupplierById = (accessToken, supplierId) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "supplier_select",
            'action': "SELECT_BY_SUPPLIER_ID",
            'variables': JSON.stringify({
                'id_supplier': supplierId
            })
        })
    });
};

export const fetSupplierOfficeID = (accessToken, supplierId) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "supplier_select",
            'action': "SELECT_BY_SUPPLIER_OFFICE_ID",
            'variables': JSON.stringify({
                'id_supplier': supplierId
            })
        })
    });
};

export const fetchSupplierByNit = (accessToken, nit) =>
    axios({
        method: 'POST',
        url: baseUrl,
        headers: { 'Authorization': `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
        data: JSON.stringify({
            process: 'supplier_select',
            action: 'SELECT_BY_IDENTIFICATION',
            variables: JSON.stringify({ identification: nit }),
        }),
    });

export const insertDataProveedor = (data, accessToken) => {
    console.log("data aqui", data)
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        data: JSON.stringify({
            process: "supplier_alter",
            action: "INSERT",
            variables: data
        })
    })
};

export const updateSupplier = (data, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "supplier_alter",
            'action': "UPDATE",
            "variables": data
        })
    });
};

export const updateOffice = (accessToken, variables) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'supplier_alter',
            'action': 'UPDATE_OFFICE',
            'variables': JSON.stringify(variables)
        })
    })
}

export const deleteOffice = (accessToken, variables) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'supplier_alter',
            'action': 'DELETE_OFFICE',
            'variables': JSON.stringify(variables)
        })
    })
}


export const getSupplierDocs = (accessToken, variables, config) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'id_user_action': config?.id_user_action ?? config.id_user_action,
            'variables': variables
        })
    })
}


export const upLoadPDF = (accessToken, data) => {
    return axios({
        method: 'POST',
        url: "https://r5ton9113k.execute-api.us-east-1.amazonaws.com/staging/rpa/flow/activate",
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: data
    })
}